import { render } from "./verticalScroll.vue?vue&type=template&id=21abd14e&scoped=true"
import script from "./verticalScroll.vue?vue&type=script&lang=js"
export * from "./verticalScroll.vue?vue&type=script&lang=js"

import "./verticalScroll.vue?vue&type=style&index=0&id=21abd14e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21abd14e"]])

export default __exports__